import React, { useState } from 'react';
// react-bootstrap
import { Container } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// styles
import { Wrapper } from './Form.styles';

const ResetPasswordForm = ({ callback, disabled }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === 'password') {
      setValues({ ...values, password: value });
    }

    if (name === 'confirmPassword') {
      setValues({ ...values, confirmPassword: value });
    }

    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!values?.password) {
      setErrors({ ...errors, password: 'Please enter password' });
      return;
    }

    if (
      !/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+){6,}$/.test(values?.password)
    ) {
      setErrors({
        ...errors,
        password:
          'Password must have at least 6 charachters length, letter, digit',
      });
      return;
    }

    if (values?.confirmPassword !== values?.password) {
      setErrors({ ...errors, confirmPassword: "Passwords doesen't match" });
      return;
    }

    callback(values.password);
  };

  return (
    <Wrapper>
      <Container>
        <h1 className={'form-title'}>Reset Password</h1>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3' controlId='formGroupPassword'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Password'
              name='password'
              value={values.password || ''}
              onChange={handleChange}
              isInvalid={errors.password}
            />
            {
              <Form.Control.Feedback type='invalid'>
                {errors.password}
              </Form.Control.Feedback>
            }
          </Form.Group>
          <Form.Group className='mb-3' controlId='formGroupConfirmPassword'>
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Password'
              name='confirmPassword'
              value={values.confirmPassword || ''}
              onChange={handleChange}
              isInvalid={errors.confirmPassword}
            />
            {
              <Form.Control.Feedback type='invalid'>
                {errors.confirmPassword}
              </Form.Control.Feedback>
            }
          </Form.Group>
          <div className='d-grid gap-2 m-5 '>
            <Button size='lg' type='submit' disabled={disabled}>
              Reset
            </Button>
          </div>
        </Form>
      </Container>
    </Wrapper>
  );
};

export default ResetPasswordForm;
